import { render, staticRenderFns } from "./asg-table-card.vue?vue&type=template&id=552cbd15&scoped=true&"
import script from "./asg-table-card.vue?vue&type=script&lang=js&"
export * from "./asg-table-card.vue?vue&type=script&lang=js&"
import style0 from "./asg-table-card.vue?vue&type=style&index=0&id=552cbd15&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552cbd15",
  null
  
)

export default component.exports